import { useEffect, useState } from 'react'
import { Dropdown } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { useThemeMode } from '../../../../../../_metronic/partials'
import clsx from 'clsx'
import { KTSVG, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import searchIcon from '../../../../../../_metronic/assets/images/svg/data-room/search-icon-grey.svg'
import { useStakeholders } from '../../../Stakeholders'
import { Filter } from '../../../../widgets/components/General/Filter'
import { TransactionModalType } from '../../core/_models'
import AddSharesModal from '../transactions/add-shares-modal'
import AddConvertibleModal from '../transactions/add-convertible-modal'
import AddBuybackModal from '../transactions/add-buyback-modal'
import AddTransferredModal from '../transactions/add-transferred-modal'
import { DataTableServerShareTransaction } from '../transactions/DataTableServerSideShareTransaction'
import AddSharedClassModal from '../security-class/add-security-class-modal'
import { DataTableServerConvertibleTransaction } from '../transactions/DataTableServerConvertibleTransaction'
import AddConvertibleClassModal from '../security-class/add-convertible-class-modal'
import AddWarrantModal from '../transactions/add-warrant-modal'
import AddWarrantClassModal from '../security-class/add-security-warrant-issuance'
import { DataTableServerWarrantTransaction } from '../transactions/DataTableServerWarrantTransaction'
import { DataTableServerBuybackTransaction } from '../transactions/DataTableServerBuybackTransaction'
import { DataTableServerTransferTransaction } from '../transactions/DataTableServerTransferTransaction'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../../hooks/gtmHelpers'
import { useAuth } from '../../../../auth'

export function IndividualTransactions() {
  const { formatMessage } = useIntl()
  const { mode } = useThemeMode()

  const sidebarOptions = [
    { title: formatMessage({ id: 'Shares' }), id: 1 },
    { title: formatMessage({ id: 'Convertible' }), id: 2 },
    { title: formatMessage({ id: 'Warrant Issuance' }), id: 3 },
    { title: formatMessage({ id: 'Buyback' }), id: 4 },
    { title: formatMessage({ id: 'Transfers' }), id: 5 },
  ]

  const [sidebar, setSidebar] = useState(1)
  const [globalFilter, setGlobalFilter] = useState('')
  const [convertibleTransactionGlobalFilter, setConvertibleTransactionGlobalFilter] = useState('')
  const [warrantGlobalFilter, setWarrantGlobalFilter] = useState('')
  const [isShareClassDropdown, setIsShareClassDropdown] = useState(false)
  const [isConvertibleClassDropdown, setIsConvertibleClassDropdown] = useState(false)
  const {
    setShareTransactionFilter,
    selectedShareTransactionSortFilter,
    setSelectedShareTransactionSortFilter,
    setSelectedShareTransactionDateFilter,
    selectedShareTransactionDateFilter,
    setConvertibleTransactionFilter,
    selectedConvertibleTransactionSortFilter,
    setSelectedConvertibleTransactionSortFilter,
    setSelectedConvertibleTransactionDateFilter,
    selectedConvertibleTransactionDateFilter,
    setWarrantTransactionFilter,
    selectedWarrantTransactionSortFilter,
    setSelectedWarrantTransactionSortFilter,
    setSelectedWarrantTransactionDateFilter,
    selectedWarrantTransactionDateFilter,
    setBuybackTransactionFilter,
    selectedBuybackTransactionSortFilter,
    setSelectedBuybackTransactionSortFilter,
    setSelectedBuybackTransactionDateFilter,
    selectedBuybackTransactionDateFilter,
    setTransferTransactionFilter,
    selectedTransferTransactionSortFilter,
    setSelectedTransferTransactionSortFilter,
    setSelectedTransferTransactionDateFilter,
    selectedTransferTransactionDateFilter,
    setCreatedShareClassEditConvertibleClassId,
    setCreatedShareClassEditWarrantClassId
  } = useStakeholders()
  const [isShareTransactionCreateOrUpdate, setIsShareTransactionCreateOrUpdate] = useState(false)
  const [modalType, setModalType] = useState<TransactionModalType>('none')
  const [isCreate, setIsCreate] = useState(true)
  const [isConvertibleCreate, setIsConvertibleCreate] = useState(true)
  const [isConvertibleTransactionCreateOrUpdate, setIsConvertibleTransactionCreateOrUpdate] =
    useState(false)
  const [isWarrantCreate, setIsWarrantCreate] = useState(true)
  const [isWarrantTransactionCreateOrUpdate, setIsWarrantTransactionCreateOrUpdate] =
    useState(false)
  const [isWarrantClassDropdown, setIsWarrantClassDropdown] = useState(false)
  const [activeModal, setActiveModal] = useState<TransactionModalType>('none')
  const [isBuybackCreate, setIsBuybackCreate] = useState(true)
  const [isBuybackTransactionCreateOrUpdate, setIsBuybackTransactionCreateOrUpdate] =
    useState(false)
  const [buybackGlobalFilter, setBuybackGlobalFilter] = useState('')
  const [isTransferTransactionCreateOrUpdate, setIsTransferTransactionCreateOrUpdate] =
    useState(false)
  const [isShareTransactionDropdown, setIsShareTransactionDropdown] = useState(false)
  const [transferGlobalFilter, setTransferGlobalFilter] = useState('')
  const [isTransferCreate, setIsTransferCreate] = useState(true)
  const { companyId, currentUser } = useAuth()
  const {
    setCreatedShareClassFromOtherClasses,
    setCreatedConvetibleClassFromOtherTransaction,
    setCreatedWarrantClassFromOtherTransaction,
    setCreatedConvertibleClassEditConvertibleTransactionId,
    setCreatedWarrantClassEditWarrantTransactionId,
  } = useStakeholders()
  const [onResetFilter, setOnResetFilter] = useState(false)

  const openModal = (modalType: TransactionModalType) => {
    setActiveModal(modalType)
  }

  const closeModal = () => {
    setActiveModal('none')
  }

  return (
    <>
      <div className='d-md-flex py-4 pt-2 justify-content-between w-100 align-items-center' style={mode === 'dark' ? { background: '#151521' } : { background: '#f5f8fa' }}>
        <div
          className={`mb-4 mb-md-0 sidebar-investor-db col-md-1 d-flex w-md-50 w-100 ${mode === 'dark' ? 'sc-tabs-line-dark' : 'sc-tabs-line'
            } `}
        >
          <div
            className=' d-flex'
            style={{
              display: 'flex',
              overflowX: 'scroll',
              whiteSpace: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {sidebarOptions.map((sideTabs: any, index: number) => (
              <>
                <ul
                  className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent text-muted fs-7 fw-semibold flex-nowrap mobile-tab-both my-md-0 mb-0 px-2 mt-0'
                  style={{ display: 'flex', flexWrap: 'nowrap', borderWidth: '0px' }}
                >
                  <div>
                    <li
                      key={index}
                      className={
                        `nav-link text-active-primary fw-normal fs-6 py-3 ps-3 d-flex align-items-center cursor-pointer` +
                        (sidebar === index + 1
                          ? '  border-top-0 border border-left-0 border-right-0 border-bottom-3 border-primary text-primary border-5'
                          : '')
                      }
                      onClick={() => {
                        setSelectedShareTransactionSortFilter('')
                        setSelectedShareTransactionDateFilter('')
                        setSelectedConvertibleTransactionSortFilter('')
                        setSelectedConvertibleTransactionDateFilter('')
                        setSelectedWarrantTransactionSortFilter('')
                        setSelectedWarrantTransactionDateFilter('')
                        setSelectedBuybackTransactionSortFilter('')
                        setSelectedBuybackTransactionDateFilter('')
                        setSelectedTransferTransactionSortFilter('')
                        setSelectedTransferTransactionDateFilter('')
                        setGlobalFilter('')
                        setConvertibleTransactionGlobalFilter('')
                        setWarrantGlobalFilter('')
                        setBuybackGlobalFilter('')
                        setTransferGlobalFilter('')
                        setSidebar(index + 1)
                        setShareTransactionFilter(false)
                        setConvertibleTransactionFilter(false)
                        setWarrantTransactionFilter(false)
                        setBuybackTransactionFilter(false)
                        setTransferTransactionFilter(false)
                        setOnResetFilter(true)

                      }}
                    >
                      {sideTabs.title}
                    </li>
                  </div>
                </ul>
              </>
            ))}
          </div>
        </div>

        <div className={`w-md-50 pb-1 ${mode === 'dark' ? 'sc-tabs-line-dark' : 'sc-tabs-line'} `}>
          {/* DROPDOWN BUTTON FOR MOBILE VIEW */}
          <Dropdown className='d-block d-md-none mb-3'>
            <Dropdown.Toggle
              id='dropdown-custom-components'
              className='btn btn-primary justify-content-center text-mute font-weight-400 font-size-13 height-40 d-flex align-items-center w-100'
            >
              {formatMessage({ id: 'Add New Transaction' })}
            </Dropdown.Toggle>

            <Dropdown.Menu className='p-0'>
              <Dropdown.Item
                eventKey='Option 1'
                className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                onClick={() => {
                  setCreatedShareClassFromOtherClasses(undefined)
                  setCreatedConvetibleClassFromOtherTransaction(undefined)
                  setCreatedWarrantClassFromOtherTransaction(undefined)
                  setCreatedConvertibleClassEditConvertibleTransactionId(undefined)
                  setCreatedWarrantClassEditWarrantTransactionId(undefined)
                  setCreatedShareClassEditConvertibleClassId(undefined)
                  setCreatedShareClassEditWarrantClassId(undefined)
                  setIsCreate(true)
                  openModal('AddSharesTransaction')
                }}
              >
                {formatMessage({ id: 'Add Shares' })}
              </Dropdown.Item>
              <Dropdown.Item
                eventKey='Option 2'
                className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                onClick={() => {
                  setCreatedShareClassFromOtherClasses(undefined)
                  setCreatedConvetibleClassFromOtherTransaction(undefined)
                  setCreatedWarrantClassFromOtherTransaction(undefined)
                  setCreatedConvertibleClassEditConvertibleTransactionId(undefined)
                  setCreatedWarrantClassEditWarrantTransactionId(undefined)
                  setCreatedShareClassEditConvertibleClassId(undefined)
                  setCreatedShareClassEditWarrantClassId(undefined)
                  setIsCreate(true)
                  openModal('AddConvertibleTransaction')
                }}
              >
                {formatMessage({ id: 'Add Convertible Shares' })}
              </Dropdown.Item>
              <Dropdown.Item
                eventKey='Option 3'
                className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                onClick={() => {
                  setCreatedShareClassFromOtherClasses(undefined)
                  setCreatedConvetibleClassFromOtherTransaction(undefined)
                  setCreatedWarrantClassFromOtherTransaction(undefined)
                  setCreatedConvertibleClassEditConvertibleTransactionId(undefined)
                  setCreatedWarrantClassEditWarrantTransactionId(undefined)
                  setCreatedShareClassEditConvertibleClassId(undefined)
                  setCreatedShareClassEditWarrantClassId(undefined)
                  setIsCreate(true)
                  openModal('AddWarrantTransaction')
                }}
              >
                {formatMessage({ id: 'Add Warrant Issuance' })}
              </Dropdown.Item>
              <Dropdown.Item
                eventKey='Option 3'
                className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                onClick={() => {
                  setCreatedShareClassFromOtherClasses(undefined)
                  setCreatedConvetibleClassFromOtherTransaction(undefined)
                  setCreatedWarrantClassFromOtherTransaction(undefined)
                  setCreatedConvertibleClassEditConvertibleTransactionId(undefined)
                  setCreatedWarrantClassEditWarrantTransactionId(undefined)
                  setCreatedShareClassEditConvertibleClassId(undefined)
                  setCreatedShareClassEditWarrantClassId(undefined)
                  setIsCreate(true)
                  openModal('AddBuybackTransaction')
                }}
              >
                {formatMessage({ id: 'Add Buyback Shares' })}
              </Dropdown.Item>
              <Dropdown.Item
                eventKey='Option 5'
                className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                onClick={() => {
                  setCreatedShareClassFromOtherClasses(undefined)
                  setCreatedConvetibleClassFromOtherTransaction(undefined)
                  setCreatedWarrantClassFromOtherTransaction(undefined)
                  setCreatedConvertibleClassEditConvertibleTransactionId(undefined)
                  setCreatedWarrantClassEditWarrantTransactionId(undefined)
                  setCreatedShareClassEditConvertibleClassId(undefined)
                  setCreatedShareClassEditWarrantClassId(undefined)
                  setIsCreate(true)
                  openModal('AddTransferredTransaction')
                }}
              >
                {formatMessage({ id: 'Add Transferred Shares' })}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className='d-flex gap-2 align-items-center justify-content-md-end justify-content-between'>
            <div className='h-100 border bg-white d-flex rounded'>
              <button
                className={clsx('text-clr88 btn btn-sm btn-flex fw-semibold font-size-12 height-36')}
                id='fc-toogle'
                title='Sort and Filter'
                data-bs-toggle='tooltip'
                data-bs-placement='left'
                data-bs-dismiss='click'
                data-bs-trigger='hover'
                onClick={() => {
                  if (sidebar === 1) {
                    setShareTransactionFilter(true)
                    if (selectedShareTransactionDateFilter || selectedShareTransactionSortFilter) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ShareTransactionFilterRemovedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                          },
                        },
                      })
                    } else {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ShareTransactionFilterAppliedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            share_transaction_type: 'Sort or Date Filter',
                          },
                        },
                      })
                    }
                  } else if (sidebar === 2) {
                    setConvertibleTransactionFilter(true)
                    if (
                      selectedConvertibleTransactionSortFilter ||
                      selectedConvertibleTransactionDateFilter
                    ) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ConvertibleTransactionFilterRemovedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                          },
                        },
                      })
                    } else {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ConvertibleTransactionFilterAppliedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            convertible_transaction_type: 'Sort or Date Filter',
                          },
                        },
                      })
                    }
                  } else if (sidebar === 3) {
                    setWarrantTransactionFilter(true)
                    if (
                      selectedWarrantTransactionSortFilter ||
                      selectedWarrantTransactionDateFilter
                    ) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.WarrantTransactionFilterRemovedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                          },
                        },
                      })
                    } else {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.WarrantTransactionFilterAppliedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            warrant_transaction_type: 'Sort or Date Filter',
                          },
                        },
                      })
                    }
                  } else if (sidebar === 4) {
                    setBuybackTransactionFilter(true)
                    if (
                      selectedBuybackTransactionSortFilter ||
                      selectedBuybackTransactionDateFilter
                    ) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.BuybackTransactionFilterRemovedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                          },
                        },
                      })
                    } else {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.BuybackTransactionFilterAppliedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            buyback_transaction_type: 'Sort or Date Filter',
                          },
                        },
                      })
                    }
                  } else if (sidebar === 5) {
                    setTransferTransactionFilter(true)
                    if (
                      selectedTransferTransactionSortFilter || selectedTransferTransactionDateFilter
                    ) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.TransferTransactionFilterRemovedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                          },
                        },
                      })
                    } else {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.TransferTransactionFilterAppliedSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            transfer_transaction_type: 'Sort or Date Filter',
                          },
                        },
                      })
                    }
                  }
                }}
              >
                <KTSVG
                  path={toAbsoluteUrl('/media/icons/duotune/general/gen031.svg')}
                  className='svg-icon-6 svg-icon-muted me-1'
                />
                <span className='d-none d-md-block'>{formatMessage({ id: 'Filter' })}</span>
                {selectedShareTransactionSortFilter || selectedShareTransactionDateFilter
                  ? '*'
                  : selectedConvertibleTransactionSortFilter ||
                    selectedConvertibleTransactionDateFilter
                    ? '*'
                    : selectedWarrantTransactionSortFilter || selectedWarrantTransactionDateFilter
                      ? '*'
                      : selectedBuybackTransactionSortFilter || selectedBuybackTransactionDateFilter
                        ? '*'
                        : selectedTransferTransactionSortFilter || selectedTransferTransactionDateFilter
                          ? '*'
                          : ''}
              </button>
            </div>

            <form className='align-items-center d-flex w-100 w-md-auto'>
              <span className='svg-icon svg-icon-3 position-absolute ms-2'>
                <img src={searchIcon} alt='Search icon' />
              </span>
              <DebouncedInput
                value={
                  sidebar === 1
                    ? globalFilter
                    : sidebar === 2
                      ? convertibleTransactionGlobalFilter
                      : sidebar === 3
                        ? warrantGlobalFilter
                        : sidebar === 4
                          ? buybackGlobalFilter
                          : sidebar === 5
                            ? transferGlobalFilter
                            : ''
                }
                onChange={(value) => {
                  if (sidebar === 1) {
                    setGlobalFilter(String(value))
                    if (String(value).length > 0) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ShareTransactionSearchSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            search_value: value,
                          },
                        },
                      })
                    }
                  } else if (sidebar === 2) {
                    setConvertibleTransactionGlobalFilter(String(value))
                    if (String(value).length > 0) {
                      TagManager.dataLayer({
                        dataLayer: {
                          event: GTMEvent.ConvertibleTransactionSearchSuccessful,
                          action: 'normal',
                          metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            search_value: value,
                          },
                        },
                      })
                    }
                  } else if (sidebar === 3) {
                    setWarrantGlobalFilter(String(value))
                    TagManager.dataLayer({
                      dataLayer: {
                        event: GTMEvent.WarrantTransactionSearchSuccessful,
                        action: 'normal',
                        metadata: {
                          company_id: companyId,
                          user_id: currentUser?.userId,
                          email: currentUser?.email,
                          search_value: value,
                        },
                      },
                    })
                  } else if (sidebar === 4) {
                    setBuybackGlobalFilter(String(value))
                    TagManager.dataLayer({
                      dataLayer: {
                        event: GTMEvent.BuybackTransactionSearchSuccessful,
                        action: 'normal',
                        metadata: {
                          company_id: companyId,
                          user_id: currentUser?.userId,
                          email: currentUser?.email,
                          search_value: value,
                        },
                      },
                    })
                  } else if (sidebar === 5) {
                    setTransferGlobalFilter(String(value))
                    TagManager.dataLayer({
                      dataLayer: {
                        event: GTMEvent.TransferTransactionSearchSuccessful,
                        action: 'normal',
                        metadata: {
                          company_id: companyId,
                          user_id: currentUser?.userId,
                          email: currentUser?.email,
                          search_value: value,
                        },
                      },
                    })
                  }
                }}
                className='bg-body form-control form-control-flush ps-10 rounded-2 font-size-12 py-2 py-md-3 font-weight-400 border'
                placeholder='Search by Class Name'
              />
            </form>
            {/* DROPDOWN BUTTON FOR DESKTOP VIEW */}
            <Dropdown className='d-none d-md-block'>
              <Dropdown.Toggle
                id='dropdown-custom-components'
                className='btn btn-primary justify-content-center text-mute font-weight-400 font-size-13 height-40 d-flex align-items-center w-100'
              >
                {formatMessage({ id: 'Add New Transaction' })}
              </Dropdown.Toggle>

              <Dropdown.Menu className='p-0'>
                <Dropdown.Item
                  eventKey='Option 1'
                  className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                  onClick={() => {
                    setIsCreate(true)
                    setCreatedShareClassFromOtherClasses(undefined)
                    setCreatedConvetibleClassFromOtherTransaction(undefined)
                    setCreatedWarrantClassFromOtherTransaction(undefined)
                    setCreatedConvertibleClassEditConvertibleTransactionId(undefined)
                    setCreatedWarrantClassEditWarrantTransactionId(undefined)
                    setCreatedShareClassEditConvertibleClassId(undefined)
                    setCreatedShareClassEditWarrantClassId(undefined)
                    openModal('AddSharesTransaction')
                  }}
                >
                  {formatMessage({ id: 'Add Shares' })}
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey='Option 2'
                  className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                  onClick={() => {
                    setIsConvertibleCreate(true)
                    setCreatedShareClassFromOtherClasses(undefined)
                    setCreatedConvetibleClassFromOtherTransaction(undefined)
                    setCreatedWarrantClassFromOtherTransaction(undefined)
                    setCreatedConvertibleClassEditConvertibleTransactionId(undefined)
                    setCreatedWarrantClassEditWarrantTransactionId(undefined)
                    setCreatedShareClassEditConvertibleClassId(undefined)
                    setCreatedShareClassEditWarrantClassId(undefined)
                    openModal('AddConvertibleTransaction')
                  }}
                >
                  {formatMessage({ id: 'Add Convertible Shares' })}
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey='Option 3'
                  className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                  onClick={() => {
                    setIsWarrantCreate(true)
                    setCreatedShareClassFromOtherClasses(undefined)
                    setCreatedConvetibleClassFromOtherTransaction(undefined)
                    setCreatedWarrantClassFromOtherTransaction(undefined)
                    setCreatedConvertibleClassEditConvertibleTransactionId(undefined)
                    setCreatedWarrantClassEditWarrantTransactionId(undefined)
                    setCreatedShareClassEditConvertibleClassId(undefined)
                    setCreatedShareClassEditWarrantClassId(undefined)
                    openModal('AddWarrantTransaction')
                  }}
                >
                  {formatMessage({ id: 'Add Warrant Issuance' })}
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey='Option 3'
                  className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                  onClick={() => {
                    setIsBuybackCreate(true)
                    setCreatedShareClassFromOtherClasses(undefined)
                    setCreatedConvetibleClassFromOtherTransaction(undefined)
                    setCreatedWarrantClassFromOtherTransaction(undefined)
                    setCreatedConvertibleClassEditConvertibleTransactionId(undefined)
                    setCreatedWarrantClassEditWarrantTransactionId(undefined)
                    setCreatedShareClassEditConvertibleClassId(undefined)
                    setCreatedShareClassEditWarrantClassId(undefined)
                    openModal('AddBuybackTransaction')
                  }}
                >
                  {formatMessage({ id: 'Add Buyback Shares' })}
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey='Option 5'
                  className={`px-2 py-2 ${mode === 'dark' ? 'link-hover-dark' : ''}`}
                  onClick={() => {
                    setIsTransferCreate(true)
                    setCreatedShareClassFromOtherClasses(undefined)
                    setCreatedConvetibleClassFromOtherTransaction(undefined)
                    setCreatedWarrantClassFromOtherTransaction(undefined)
                    setCreatedConvertibleClassEditConvertibleTransactionId(undefined)
                    setCreatedWarrantClassEditWarrantTransactionId(undefined)
                    setCreatedShareClassEditConvertibleClassId(undefined)
                    setCreatedShareClassEditWarrantClassId(undefined)
                    openModal('AddTransferredTransaction')
                  }}
                >
                  {formatMessage({ id: 'Add Transferred Shares' })}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
      </div>

      <div className='bg-white rounded-top position-relative mb-4'>
        {sidebar === 1 && (
          <DataTableServerShareTransaction
            openModal={openModal}
            closeModal={closeModal}
            activeModal={activeModal}
            setIsCreate={setIsCreate}
            setSidebar={setSidebar}
            globalFilter={globalFilter}
            setGlobalFilter={setGlobalFilter}
            selectedShareTransactionSortFilter={selectedShareTransactionSortFilter}
            selectedShareTransactionDateFilter={selectedShareTransactionDateFilter}
            isShareTransactionCreateOrUpdate={isShareTransactionCreateOrUpdate}
            setIsShareTransactionCreateOrUpdate={setIsShareTransactionCreateOrUpdate}
            setModalType={setModalType}
            setIsShareClassDropdown={setIsShareClassDropdown}
          />
        )}{' '}
        {sidebar === 2 && (
          <DataTableServerConvertibleTransaction
            openModal={openModal}
            closeModal={closeModal}
            activeModal={activeModal}
            setIsConvertibleCreate={setIsConvertibleCreate}
            setSidebar={setSidebar}
            convertibleTransactionGlobalFilter={convertibleTransactionGlobalFilter}
            setConvertibleTransactionGlobalFilter={setConvertibleTransactionGlobalFilter}
            selectedConvertibleTransactionSortFilter={selectedConvertibleTransactionSortFilter}
            selectedConvertibleTransactionDateFilter={selectedConvertibleTransactionDateFilter}
            isConvertibleTransactionCreateOrUpdate={isConvertibleTransactionCreateOrUpdate}
            setIsConvertibleTransactionCreateOrUpdate={setIsConvertibleTransactionCreateOrUpdate}
            setModalType={setModalType}
            setIsConvertibleClassDropdown={setIsConvertibleClassDropdown}
          />
        )}{' '}
        {sidebar === 3 && (
          <>
            <DataTableServerWarrantTransaction
              openModal={openModal}
              closeModal={closeModal}
              activeModal={activeModal}
              setIsWarrantCreate={setIsWarrantCreate}
              setSidebar={setSidebar}
              warrantGlobalFilter={warrantGlobalFilter}
              setWarrantGlobalFilter={setWarrantGlobalFilter}
              selectedWarrantTransactionSortFilter={selectedWarrantTransactionSortFilter}
              selectedWarrantTransactionDateFilter={selectedWarrantTransactionDateFilter}
              isWarrantTransactionCreateOrUpdate={isWarrantTransactionCreateOrUpdate}
              setIsWarrantTransactionCreateOrUpdate={setIsWarrantTransactionCreateOrUpdate}
              setModalType={setModalType}
              setIsWarrantClassDropdown={setIsWarrantClassDropdown}
            />
          </>
        )}
        {sidebar === 4 && (
          <DataTableServerBuybackTransaction
            openModal={openModal}
            closeModal={closeModal}
            activeModal={activeModal}
            setIsBuybackCreate={setIsBuybackCreate}
            setSidebar={setSidebar}
            buybackGlobalFilter={buybackGlobalFilter}
            setBuybackGlobalFilter={setBuybackGlobalFilter}
            selectedBuybackTransactionSortFilter={selectedBuybackTransactionSortFilter}
            selectedBuybackTransactionDateFilter={selectedBuybackTransactionDateFilter}
            isBuybackTransactionCreateOrUpdate={isBuybackTransactionCreateOrUpdate}
            setIsBuybackTransactionCreateOrUpdate={setIsBuybackTransactionCreateOrUpdate}
            setModalType={setModalType}
            setIsShareClassDropdown={setIsShareClassDropdown}
          />
        )}
        {sidebar === 5 && (
          <DataTableServerTransferTransaction
            openModal={openModal}
            closeModal={closeModal}
            activeModal={activeModal}
            setIsTransferCreate={setIsTransferCreate}
            setSidebar={setSidebar}
            transferGlobalFilter={transferGlobalFilter}
            setTransferGlobalFilter={setTransferGlobalFilter}
            selectedTransferTransactionSortFilter={selectedTransferTransactionSortFilter}
            selectedTransferTransactionDateFilter={selectedTransferTransactionDateFilter}
            isTransferTransactionCreateOrUpdate={isTransferTransactionCreateOrUpdate}
            setIsTransferTransactionCreateOrUpdate={setIsTransferTransactionCreateOrUpdate}
            setModalType={setModalType}
            setIsShareTransactionDropdown={setIsShareTransactionDropdown}
          />
        )}
      </div>
      {activeModal === 'AddSharesTransaction' && isCreate && (
        <AddSharesModal
          openModal={openModal}
          isActive={true}
          setIsActive={closeModal}
          shareTransactionId={null}
          setIsShareTransactionCreateOrUpdate={setIsShareTransactionCreateOrUpdate}
          setSidebar={setSidebar}
          setModalType={setModalType}
          setIsShareClassDropdown={setIsShareClassDropdown}
          setIsCreate={setIsCreate}
          setIsShareTransactionDropdown={setIsShareTransactionDropdown}
          isShareTransactionDropdown={isShareTransactionDropdown}
          modalType={modalType}
        />
      )}
      {activeModal === 'AddConvertibleTransaction' && isConvertibleCreate && (
        <AddConvertibleModal
          isActive={true}
          setIsActive={closeModal}
          setIsConvertibleTransactionCreateOrUpdate={setIsConvertibleTransactionCreateOrUpdate}
          setSidebar={setSidebar}
          convertibleTransactionId={null}
          openModal={openModal}
          setIsConvertibleClassDropdown={setIsConvertibleClassDropdown}
          setModalType={setModalType}
          setIsConvertibleCreate={setIsConvertibleCreate}
        />
      )}
      {activeModal === 'AddWarrantTransaction' && isWarrantCreate && (
        <AddWarrantModal
          isActive={true}
          setIsActive={closeModal}
          setIsWarrantTransactionCreateOrUpdate={setIsWarrantTransactionCreateOrUpdate}
          warrantTransactionId={null}
          setSidebar={setSidebar}
          openModal={openModal}
          setIsWarrantClassDropdown={setIsWarrantClassDropdown}
          setModalType={setModalType}
          setIsWarrantCreate={setIsWarrantCreate}
        />
      )}
      {activeModal === 'AddBuybackTransaction' && isBuybackCreate && (
        <AddBuybackModal
          isActive={true}
          setIsActive={closeModal}
          setIsBuybackTransactionCreateOrUpdate={setIsBuybackTransactionCreateOrUpdate}
          buybackTransactionId={null}
          setSidebar={setSidebar}
          openModal={openModal}
          setIsShareClassDropdown={setIsShareClassDropdown}
          setModalType={setModalType}
          setIsBuybackCreate={setIsBuybackCreate}
          isBuybackCreate={isBuybackCreate}
        />
      )}
      {activeModal === 'AddTransferredTransaction' && isTransferCreate && (
        <AddTransferredModal
          isActive={true}
          setIsActive={closeModal}
          setIsTransferTransactionCreateOrUpdate={setIsTransferTransactionCreateOrUpdate}
          transferTransactionId={null}
          setSidebar={setSidebar}
          openModal={openModal}
          setIsShareTransactionDropdown={setIsShareTransactionDropdown}
          setModalType={setModalType}
          setIsTransferCreate={setIsTransferCreate}
        />
      )}
      {activeModal === 'AddSecurityClassModal' && (
        <AddSharedClassModal
          openModal={openModal}
          isActive={true}
          setIsActive={closeModal}
          shareClassId={null}
          setIsCreateOrUpdate={setIsShareTransactionCreateOrUpdate}
          setSidebar={setSidebar}
          shareClassDropdown={isShareClassDropdown}
          setShareClassDropdown={setIsShareClassDropdown}
          modalType={modalType}
          setModalType={setModalType}
        />
      )}
      {activeModal === 'AddConvertibleClassModal' && (
        <AddConvertibleClassModal
          isActive={true}
          setIsActive={closeModal}
          setIsConvertibleCreateOrUpdate={setIsConvertibleTransactionCreateOrUpdate}
          setSidebar={setSidebar}
          openModal={openModal}
          setIsShareClassDropdown={setIsShareClassDropdown}
          setModalType={setModalType}
          modalType={modalType}
          setIsCreate={setIsCreate}
          convertibleClassDropdown={isConvertibleClassDropdown}
          setConvertibleClassDropdown={setIsConvertibleClassDropdown}
        />
      )}
      {activeModal === 'AddWarrantClassModal' && (
        <AddWarrantClassModal
          isActive={true}
          setIsActive={closeModal}
          setIsWarrantCreateOrUpdate={setIsWarrantTransactionCreateOrUpdate}
          setSidebar={setSidebar}
          openModal={openModal}
          setIsShareClassDropdown={setIsShareClassDropdown}
          setModalType={setModalType}
          setIsCreate={setIsCreate}
          modalType={modalType}
          warrantClassDropdown={isWarrantClassDropdown}
          setWarrantClassDropdown={setIsWarrantClassDropdown}
        />
      )}
      <Filter onResetFilter={onResetFilter} setOnResetFilter={setOnResetFilter} />
    </>
  )
}

function DebouncedInput({
  value: initialValue,
  onChange,
  debounce = 500,
  ...props
}: {
  value: string | number
  onChange: (value: string | number) => void
  debounce?: number
} & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = useState(initialValue)

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  useEffect(() => {
    const timeout = setTimeout(() => {
      onChange(value)
    }, debounce)

    return () => clearTimeout(timeout)
  }, [value, debounce, onChange])
  return <input {...props} value={value} onChange={(e) => setValue(e.target.value)} />
}
